// extracted by mini-css-extract-plugin
module.exports = {"Test":"Test__Test--3W0JV","TestWrapper":"Test__TestWrapper--2vZXr"};